import { defineComponent as d, createBlock as a, openBlock as r, unref as t, mergeProps as h, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const m = /* @__PURE__ */ d({
  name: "IconFigma",
  __name: "IconFigma",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (i, l) => (r(), a(t(u), h(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...l[0] || (l[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M11.405 2.5h3.64a3.563 3.563 0 0 1 0 7.127h-3.64V2.5m1.19 1.19v4.747h2.45a2.373 2.373 0 1 0 0-4.747h-2.45",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.391 6.063A3.563 3.563 0 0 1 8.955 2.5h3.64v7.127h-3.64A3.563 3.563 0 0 1 5.39 6.063M8.955 3.69a2.373 2.373 0 1 0 0 4.747h2.45V3.69h-2.45",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.391 12a3.564 3.564 0 0 1 3.564-3.563h3.64v7.127h-3.64A3.563 3.563 0 0 1 5.39 12m3.564-2.373a2.373 2.373 0 0 0 0 4.746h2.45V9.627h-2.45",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.391 17.937a3.563 3.563 0 0 1 3.564-3.564h3.64v3.525c0 1.994-1.637 3.602-3.621 3.602-1.963 0-3.583-1.59-3.583-3.563m3.564-2.374a2.373 2.373 0 0 0-2.374 2.374c0 1.305 1.077 2.373 2.393 2.373 1.337 0 2.43-1.085 2.43-2.412v-2.335h-2.45",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M11.405 12a3.563 3.563 0 0 1 3.563-3.563h.077a3.564 3.564 0 0 1 0 7.127h-.077A3.563 3.563 0 0 1 11.405 12m3.563-2.373a2.373 2.373 0 1 0 0 4.746h.077a2.373 2.373 0 1 0 0-4.746h-.077",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  m as default
};
